import { render, staticRenderFns } from "./proceedingsDetailAppr.vue?vue&type=template&id=2ceb68a8"
import script from "./proceedingsDetailAppr.vue?vue&type=script&lang=js"
export * from "./proceedingsDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ceb68a8')) {
      api.createRecord('2ceb68a8', component.options)
    } else {
      api.reload('2ceb68a8', component.options)
    }
    module.hot.accept("./proceedingsDetailAppr.vue?vue&type=template&id=2ceb68a8", function () {
      api.rerender('2ceb68a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sai/osh/proceedingsDetailAppr.vue"
export default component.exports